import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin} from "@fortawesome/free-brands-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import  logo  from "../assets/Logo.png";
import '../styles/variables.css';
import '../styles/Header.css';


const Header = ({setOpenMenu}:any) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/`);
        
    }

    return (
        <header className="header">
            <div className="header-logo" onClick={handleClick}>
                <picture>
                    <img src={logo} alt="Logo geomunioz" className="h-12 w-12 object-contain" />
                </picture>
                <span className="header-title">geomunioz</span>
            </div>
            <div className="header-links">
                <a href="/" className="btn-link__menu">Inicio</a>
                <a href="/about" className="btn-link__menu">Acerca de</a>
                <a href="/projects" className="btn-link__menu">Proyectos</a>
                <a href="#" className="btn-menu" onClick={setOpenMenu}>
                    <FontAwesomeIcon icon={faBars} />
                </a>
                <a href="https://github.com/geomunioz" className="btn-link">
                    <FontAwesomeIcon icon={faGithub} />
                </a>
                <a href="https://www.linkedin.com/in/geomunioz/" className="btn-link">
                    <FontAwesomeIcon icon={faLinkedin} />
                </a>
            </div>
        </header>
    )
} 

export default Header;